import React from 'react';

type TableViewerProps = {
  children: React.ReactNode;
  className?: string;
  viewportClassName?: string;
};

/**
 * Shared table viewport for File Explorer tables.
 * Fills available height and supports both vertical + horizontal scrolling.
 */
export default function TableViewer(props: TableViewerProps): React.ReactElement {
  const { children, className = '', viewportClassName = '' } = props;

  return (
    <div className={`h-full min-h-0 w-full ${className}`}>
      <div
        className={`h-full w-full overflow-x-auto overflow-y-auto overscroll-contain ${viewportClassName}`}
      >
        {children}
      </div>
    </div>
  );
}

